import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CartDrawer from './CartDrawer';

export default function PublicLayout() {
    return (
        <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--brand-blush)' }}>
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <CartDrawer />
        </div>
    );
}
